import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getInitials(
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
): string {
  const first = firstName?.[0] || "";
  const last = lastName?.[0] || "";

  if (first || last) {
    return (first + last).toUpperCase();
  }

  return email?.slice(0, 2).toUpperCase() || "U";
}

export interface DistributionItem {
  label: string;
  count: number;
  percentage: number;
}

export function aggregateData<T extends Record<string, unknown>>(
  data: readonly T[],
  field: keyof T & string,
): DistributionItem[] {
  const counts: Record<string, number> = {};
  let totalValid = 0;

  for (const item of data) {
    const raw = item[field];
    if (raw == null) continue;

    const normalized = String(raw).trim();
    if (normalized === "") continue;

    const value = normalized.toUpperCase();
    counts[value] = (counts[value] ?? 0) + 1;
    totalValid++;
  }

  return Object.entries(counts)
    .map(([label, count]) => ({
      label,
      count,
      percentage:
        totalValid > 0 ? Number(((count / totalValid) * 100).toFixed(1)) : 0,
    }))
    .sort((a, b) => b.count - a.count);
}